import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";

export const DELETE_IMG_REQUEST = "DELETE_IMG_REQUEST";
export const DELETE_IMG_SUCCESS = "DELETE_IMG_SUCCESS";
export const DELETE_IMG_FAIL = "DELETE_IMG_FAIL";

export const deleteImg = (name: string) => (dispatch: any): any => {
  dispatch({ type: DELETE_IMG_REQUEST });

  const token = getToken();

  return api
    .deleteImg(token, name)
    .then((response: AxiosResponse) => {
      const name: string = get(response, "data", {});
      dispatch({
        type: DELETE_IMG_SUCCESS,
        payload: name
      });

      return name;
    })
    .catch(err => {
      dispatch({
        type: DELETE_IMG_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
